import script from "./RefetchLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./RefetchLoading.vue?vue&type=script&setup=true&lang=js"

import "./RefetchLoading.vue?vue&type=style&index=0&id=198adf77&lang=css"

const __exports__ = script;

export default __exports__